import { Button, Col, Form, Row } from "react-bootstrap";
import { PlusCircle } from "react-bootstrap-icons";

/**
 * Props for AddLinkButton component.
 */
interface AddLinkButtonProps {
  /**
   * Text to display after the plus icon
   */
  label: string;
  /**
   * Handler function when button is clicked
   */
  onClick: () => void;
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;
  /**
   * Column width for the button container (Bootstrap grid columns)
   */
  colWidth?: number;
  /**
   * Optional additional CSS classes
   */
  className?: string;
}

/**
 * A link-styled button with a plus icon for adding items.
 * Displayed as a form group with configurable column width.
 *
 * @param props - Component props
 * @param props.label - Text to display after the plus icon
 * @param props.onClick - Handler function when button is clicked
 * @param props.disabled - Whether the button is disabled
 * @param props.colWidth - Column width for the button container (default: 9)
 * @param props.className - Optional additional CSS classes
 */
export const AddLinkButton = ({
  label,
  onClick,
  disabled = false,
  colWidth = 9,
  className = "",
}: AddLinkButtonProps): React.ReactElement => {
  return (
    <Form.Group
      as={Row}
      className={`mb-3 ${className}`}
    >
      <Col sm={colWidth}>
        <Button
          variant="link"
          className="p-0 text-primary d-flex align-items-center text-decoration-none"
          onClick={onClick}
          disabled={disabled}
        >
          <PlusCircle
            size={16}
            className="me-1"
          />
          {label}
        </Button>
      </Col>
    </Form.Group>
  );
};

AddLinkButton.displayName = "AddLinkButton";
